import React from "react";
import {
  IonCol,
  IonGrid,
  IonIcon,
  IonImg,
  IonRouterLink,
  IonRow,
  isPlatform,
} from "@ionic/react";

import {AppButton, AppCards, Breadcrumbs} from "../../../components";

import {useQuery} from "@apollo/client";
import {GET_POPULAR_SERVICES} from "../../../graphql/queries/service.query";
import {GET_PAGINATED_CART_ITEM_QUERY} from "../../../graphql/queries/common.query";
import {logOutOutline} from "ionicons/icons";

import Ordini from "../../../assets/images/ordini.png";
import OrdiniAttesa from "../../../assets/images/ordini-attesa.png";
import Preventivi from "../../../assets/images/preventivi.png";
import Fatture from "../../../assets/images/fatture.png";
import Dati from "../../../assets/images/dati.png";

import "./area.style.css";
import {Link} from "react-router-dom";
import {AuthContext} from "../../../context/AuthContext";

const PersonalArea = () => {
  const [servicesList, setServicesList] = React.useState([]);
  const [pendingServices, setPendingServices] = React.useState(0);
  const {logout} = React.useContext(AuthContext);

  useQuery(GET_POPULAR_SERVICES, {
    fetchPolicy: "cache-and-network",
    onCompleted(data) {
      setServicesList(data?.getPopularService?.data);
    },
  });

  useQuery(GET_PAGINATED_CART_ITEM_QUERY, {
    fetchPolicy: "cache-and-network",
    onCompleted(data) {
      const count = data.getPaginatedCartItem?.data?.length;
      setPendingServices(count);
    },
  });

  const breadcrumbEntries = [{title: "Area personale"}];

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />
      {isPlatform("android") || isPlatform("ios") ? (
        <MobileView
          pendingServices={pendingServices}
          servicesList={servicesList}
          logout={logout}
        />
      ) : (
        <DesktopView
          pendingServices={pendingServices}
          servicesList={servicesList}
          logout={logout}
        />
      )}
    </div>
  );
};

function MobileView(props: any) {
  const [activeTab, setActiveTab] = React.useState("profile");

  const profileTabs = [
    {
      title: "LE MIE PRATICHE",
      link: "/personale/servizi",
      image: Ordini,
    },
    {
      title: "PRATICHE IN ATTESA",
      link: "/personale/attesa",
      image: OrdiniAttesa,
      hasBadge: true,
    },
    {
      title: "PREVENTIVI",
      link: "/personale/preventivi",
      image: Preventivi,
    },
    {
      title: "FATTURE",
      link: "/personale/invoices",
      image: Fatture,
    },
    {
      title: "I MIEI DATI",
      link: "/personale/dati",
      image: Dati,
    },
  ];

  return (
    <div className="mobile-view-profile">
      <div className="tab-buttons">
        <IonGrid className="tab-buttons-grid">
          <IonRow>
            <IonCol>
              <button
                className={activeTab === "profile" ? "button-active" : ""}
                onClick={() => setActiveTab("profile")}
              >
                Area personale
              </button>
            </IonCol>
            <IonCol>
              <button
                className={activeTab === "popular" ? "button-active" : ""}
                onClick={() => setActiveTab("popular")}
              >
                I servizi che richiedo di più
              </button>
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>

      {activeTab === "profile" && (
        <div>
          {profileTabs.map((tab, index) => (
            <IonRouterLink href={tab.link} key={index}>
              <div className="mobile-profile-category">
                <IonImg
                  src={tab.image}
                  alt={tab.title}
                  className="mobile-profile-category-image"
                />
                <div className="title-text">
                  <p>{tab.title}</p>
                </div>
                {tab.hasBadge && props.pendingServices > 0 && (
                  <div className="mobile-active-badge">
                    {props.pendingServices}
                  </div>
                )}
              </div>
            </IonRouterLink>
          ))}
        </div>
      )}

      {activeTab === "popular" && (
        <div>
          {props.servicesList?.map((service: any, index: number) => (
            <Link
              to={{
                pathname: `/servizi/details/${service.id}`,
                state: {
                  categoryName: service.category.name,
                  serviceName: service.name,
                },
              }}
              key={index}
            >
              <div className="service-list-item-mobile">
                <div className="service-list-item-text-mobile">
                  {service.name}
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}

      <div className="logout-mobile">
        <AppButton onClick={() => props.logout()}>
          <IonIcon slot="icon-only" icon={logOutOutline} /> Logout
        </AppButton>
      </div>
    </div>
  );
}

function DesktopView(props: any) {
  return (
    <div>
      <div className="full-page-content-personal-area">
        <IonRouterLink href="/personale/servizi">
          <AppCards title="LE MIE PRATICHE" image={Ordini} size="small" />
        </IonRouterLink>
        <IonRouterLink href="/personale/attesa">
          <AppCards
            title="PRATICHE IN ATTESA"
            image={OrdiniAttesa}
            size="small"
            badge={props.pendingServices}
          />
        </IonRouterLink>
        <IonRouterLink href="/personale/preventivi">
          <AppCards title="PREVENTIVI" image={Preventivi} size="small" />
        </IonRouterLink>
        <IonRouterLink href="/personale/invoices">
          <AppCards title="FATTURE" image={Fatture} size="small" />
        </IonRouterLink>
        <IonRouterLink href="/personale/dati">
          <AppCards title="I MIEI DATI" image={Dati} size="small" />
        </IonRouterLink>
      </div>

      <div className="container-of-some-kind">
        <h2 className="personale-title">I servizi che richiedo di più</h2>
        <div className="service-list">
          {props.servicesList.map((service: any, index: number) => (
            <Link
              to={{
                pathname: `/servizi/details/${service.id}`,
                state: {
                  categoryName: service.category.name,
                  serviceName: service.name,
                },
              }}
              key={index}
            >
              <div className="service-list-item">
                <div className="service-list-item-text"> {service.name} </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <br />

      <div className="container-of-some-kind the-logout-kind">
        <AppButton onClick={() => props.logout()}>
          <IonIcon slot="icon-only" icon={logOutOutline} /> Logout
        </AppButton>
      </div>

      <br />
    </div>
  );
}

export default PersonalArea;
